import styled from "styled-components";

const Block = styled.div(({ theme }) => ({
  flex: "0 1 auto",
  fontSize: "14px",
  left: 0,
  maxWidth: "fit-content",
  overflow: "hidden",
  padding: theme.sizes.x1,
  position: "sticky",
}));

export default Block;
